import React ,{ Component }from "react";
import { FiCast , FiLayers , FiUsers , FiMonitor } from "react-icons/fi";

const ServiceList = [
    {
        icon: <FiCast />,
        title: 'Project Management Mentorship Program',
        description: "",
        url: '/pmmp'
    },
    {
        icon: <FiLayers />,
        title: "Change Leadership",
        description: "Driving Transformation, Inspiring Teams",
        url: '/change-leadership'
    },
    {
        icon: <FiUsers />,
        title: "Business Transformation Catalyst",
        description: "Strategic Vision and Execution",
        url: '/business-transformation-catalyst'
    }
]


class ServiceThree extends Component{
    render(){
        const {column } = this.props;
        const ServiceContent = ServiceList.slice(0 , this.props.item);
        
        return(
            <React.Fragment>
                <div className="row">
                    {ServiceContent.map( (val , i) => (
                        <div className={`${column}`} key={i}>
                            <a href={val.url}>
                                <div className="service service__style--2 py-0">
                                    <div className="icon">
                                        {val.icon}
                                    </div>
                                    <div className="content">
                                        {/* <h3 className="title text-center">{val.title}</h3> */}
                                        <h6 className="text-center">{val.title}</h6>
                                        <p className="text-center">{val.description}</p>
                                    </div>
                                </div>
                            </a>
                        </div>
                    ))}
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceThree;
